import { Interceptors } from 'use-http';
import { useDisconnect } from 'wagmi';
import { lsKey, useUserContext } from '../context/user.context';

interface UseAppHookType {
  options: {
    interceptors: Interceptors;
  };
}

export function useHttpInterceptor(): UseAppHookType {
  const { disconnect } = useDisconnect();
  const { setIsLoggedIn } = useUserContext();
  // @TODO replace any with proper type
  const options: any = {
    persist: false,
    cachePolicy: 'no-cache',
    interceptors: {
      request: async ({
        options,
      }: {
        options: { headers: { Authorization: string } };
      }) => {
        const lsToken = localStorage.getItem(lsKey);

        if (lsToken !== '') {
          options.headers.Authorization = `Bearer ${lsToken}`;
        }
        return options;
      },
      response: ({
        response,
      }: {
        response: { data: { statusCode: number } };
      }) => {
        if (response?.data?.statusCode === 401) {
          setIsLoggedIn(false);
          disconnect();
        }
        return response;
      },
    },
  };

  return {
    options,
  };
}
